module.exports = __webpack_public_path__ + "img/1974337_orig.8a47826d.png";